import { render } from "./gzxx.vue?vue&type=template&id=08ba3482&scoped=true&ts=true"
import script from "./gzxx.vue?vue&type=script&lang=ts"
export * from "./gzxx.vue?vue&type=script&lang=ts"

import "./gzxx.vue?vue&type=style&index=0&id=08ba3482&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ba3482"]])

export default __exports__